import { Grid, Stack, Typography } from "@mui/material";
import EditButton from "../EditButton";
import {
  FormGetField,
  FormGetResponse,
  FormsGetResponse,
} from "../../models/Form";
import dayjs from "dayjs";
import { observer } from "mobx-react";

const CareDaysDayList = observer(
  <T extends FormsGetResponse>({
    items,
    onClick,
  }: {
    items: T[];
    onClick: (day: any) => void;
  }) => {
    const sortedItems = items
      ?.filter((a) => a.values.length > 0)
      .sort((a, b) => {
        const dateA = dayjs(
          (a as unknown as FormGetResponse).values.find(
            (a) => a.fieldAlias === "D_CareDays_1_DateStart"
          )?.value
        ).valueOf();
        const dateB = dayjs(
          (b as unknown as FormGetResponse).values.find(
            (a) => a.fieldAlias === "D_CareDays_1_DateStart"
          )?.value
        ).valueOf();
        return dateB - dateA;
      });
    return (
      <>
        {sortedItems?.map((item, index) => {
          const values = item.values as unknown as FormGetField[];
          const startDate = values.find(
            (a) => a.fieldAlias === "D_CareDays_1_DateStart"
          )?.value;
          const endDate = values.find(
            (a) => a.fieldAlias === "D_CareDays_2_DateEnd"
          )?.value;
          const infectionRelated = values.find(
            (a) => a.fieldAlias === "D_CareDays_3_Infection"
          )?.value;
          const numberOfDays = values.find(
            (a) => a.fieldAlias === "C_D_CareDaysNbrOfDays"
          )?.value;
          return (
            <Grid
              container
              key={`${item[index]?.clientFormId}-${index}`}
              p={2}
              sx={{ borderBottom: "1px solid lightgrey" }}
              spacing={2}
            >
              <Grid item md={12} lg={3}>
                <Typography sx={{ marginBottom: 1 }}>
                  <b>Från datum: </b>
                  {startDate ? startDate.substring(0, 10) : "-"}
                </Typography>
                <EditButton onClick={() => onClick(item)} />
              </Grid>
              <Grid item md={12} lg={9}>
                <Stack direction="column">
                  <Typography>
                    <b>Till datum: </b>
                    {endDate ? endDate.substring(0, 10) : "-"}
                  </Typography>
                  <Typography>
                    <b>Infektionsrelaterat: </b>
                    {infectionRelated}
                  </Typography>
                  <Typography>
                    <b>Antal dagar: </b>
                    {numberOfDays}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          );
        })}
      </>
    );
  }
);

export default CareDaysDayList;
